import {
  Box,
  Flex,
  Grid,
  Heading,
  IconButton,
} from "@sidelinesports/fan-design-system";
import { InfoFillIcon } from "@sidelinesports/icons";
import { clsx } from "clsx";
import type { ApiPlayerDetails } from "../../../../api";
import { Dialog } from "../../../../components/Dialog";
import { PlayerProfile } from "../PlayerProfile";
import styles from "./PlayerCard.module.css";

export type PlayerCardProps = {
  player: ApiPlayerDetails;
  disabled?: boolean;
  selected?: boolean;
  onClick: () => void;
};

export const PlayerCard = ({
  player,
  disabled = false,
  selected = false,
  onClick,
}: PlayerCardProps) => {
  return (
    <label className={styles.label}>
      <input
        type="checkbox"
        className={clsx(styles["visually-hidden"], styles.checkbox)}
        aria-describedby={`player-${player.id}-description`}
        disabled={disabled}
        checked={selected}
        onChange={onClick}
      />
      <div className={styles["interior-clipping-container"]}>
        <div
          className={styles["image-overlay"]}
          style={{
            backgroundImage: `url(${player.headshot.url})`,
          }}
        />
        <div className={styles.overlay} />
        <Flex direction="column" justify="between" h="100%" w="100%">
          <Box className={styles["info-button-container"]} p={16}>
            <PlayerProfile
              player={player}
              trigger={
                <Dialog.Trigger
                  as={IconButton}
                  icon={<InfoFillIcon />}
                  variant="outline-light"
                  size="lg"
                  aria-label="More Info"
                />
              }
            />
          </Box>
          <Grid
            id={`player-${player.id}-name`}
            className={styles["player-name-container"]}
            p={16}
          >
            <Heading as="div" level={5}>
              {player.firstName}
            </Heading>
            <Heading as="div" level={3}>
              {player.lastName}
            </Heading>
          </Grid>
        </Flex>
        <div
          id={`player-${player.id}-description`}
          className={styles["visually-hidden"]}
        >
          {selected ? "Selected" : "Not selected"} player card for{" "}
          {player.firstName} {player.lastName}.
          {disabled && !selected
            ? " This player is not available: maximum selections reached."
            : ""}
        </div>
      </div>
    </label>
  );
};
